
    import React from 'react'

    // prefer default export if available
    const preferDefault = m => m && m.default || m
    const rootRoute = { childRoutes: [
      {
        path:'/',
        component: preferDefault(require('/Users/noviny/Development/packages/keystone/www/layouts/default')),
        indexRoute: 
      {
        
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/index.js'))
            require.ensure([], (require) => {
              const data = require('./json/index.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---index')
          }, 'page-component---pages-index-js')
        }
      },
    
        childRoutes: [
      
      {
        path:'/offline-plugin-app-shell-fallback/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/node_modules/gatsby-plugin-offline/app-shell.js'))
            require.ensure([], (require) => {
              const data = require('./json/offline-plugin-app-shell-fallback.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---offline-plugin-app-shell-fallback')
          }, 'page-component---node-modules-gatsby-plugin-offline-app-shell-js')
        }
      },
    
      {
        path:'/getting-started',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/getting-started.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---getting-started')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/getting-started/yo-generator',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/getting-started-yo-generator.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---getting-started-yo-generator')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/getting-started/setting-up/part-1',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/getting-started-setting-up-part-1.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---getting-started-setting-up-part-1')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/getting-started/setting-up/part-2',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/getting-started-setting-up-part-2.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---getting-started-setting-up-part-2')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/getting-started/setting-up/part-3',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/getting-started-setting-up-part-3.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---getting-started-setting-up-part-3')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/getting-started/setting-up/part-4',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/getting-started-setting-up-part-4.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---getting-started-setting-up-part-4')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/options',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-options.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-options')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/close-database-connection',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-close-database-connection.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-close-database-connection')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/create-items',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-create-items.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-create-items')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/create-router',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-create-router.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-create-router')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/get',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-get.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-get')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/import',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-import.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-import')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/importer',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-importer.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-importer')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/init',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-init.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-init')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/list',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-list.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-list')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/middleware',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-middleware.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-middleware')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/open-database-connection',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-open-database-connection.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-open-database-connection')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/paginate',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-paginate.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-paginate')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/pre',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-pre.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-pre')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/set',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-set.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-set')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/start',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-start.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-start')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/methods/update-handler',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-methods-update-handler.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-methods-update-handler')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/view',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-view.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-view')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/view/on',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-view-on.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-view-on')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/view/query',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-view-query.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-view-query')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/view/render',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-view-render.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-view-render')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list/add',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list-add.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list-add')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list/model',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list-model.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list-model')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list/options',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list-options.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list-options')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list/register',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list-register.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list-register')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list/schema',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list-schema.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list-schema')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/list/update-item',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-list-update-item.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-list-update-item')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/guides/api-file-image-uploads',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/guides-api-file-image-uploads.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---guides-api-file-image-uploads')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/guides/how-to-create-a-blog-with-keystone',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/guides-how-to-create-a-blog-with-keystone.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---guides-how-to-create-a-blog-with-keystone')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/guides/how-to-send-emails',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/guides-how-to-send-emails.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---guides-how-to-send-emails')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/guides',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/guides.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---guides')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/guides/v-0-3-to-v-4-0-upgrade-guide',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/guides-v-0-3-to-v-4-0-upgrade-guide.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---guides-v-0-3-to-v-4-0-upgrade-guide')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/documentation/application-updates',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/documentation-application-updates.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---documentation-application-updates')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/documentation',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/documentation.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---documentation')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/documentation/configuration',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/documentation-configuration.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---documentation-configuration')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/documentation/database',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/documentation-database.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---documentation-database')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/documentation/database/relationships',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/documentation-database-relationships.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---documentation-database-relationships')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/azurefile',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-azurefile.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-azurefile')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/file',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-file.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-file')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/embedly',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-embedly.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-embedly')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/localfiles',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-localfiles.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-localfiles')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/localfile',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-localfile.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-localfile')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/s-3-file',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-s-3-file.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-s-3-file')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/boolean',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-boolean.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-boolean')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/cloudinaryimage',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-cloudinaryimage.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-cloudinaryimage')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/code',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-code.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-code')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/cloudinaryimages',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-cloudinaryimages.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-cloudinaryimages')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/color',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-color.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-color')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/date',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-date.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-date')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/datearray',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-datearray.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-datearray')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/datetime',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-datetime.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-datetime')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/geopoint',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-geopoint.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-geopoint')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/email',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-email.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-email')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/key',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-key.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-key')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/html',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-html.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-html')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/money',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-money.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-money')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/location',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-location.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-location')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/markdown',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-markdown.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-markdown')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/name',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-name.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-name')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/password',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-password.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-password')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/number',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-number.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-number')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/numberarray',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-numberarray.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-numberarray')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/relationship',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-relationship.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-relationship')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/select',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-select.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-select')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/text',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-text.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-text')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/textarea',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-textarea.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-textarea')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/textarray',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-textarray.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-textarray')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/api/field/url',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/templates/template-doc-layout.js'))
            require.ensure([], (require) => {
              const data = require('./json/api-field-url.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---api-field-url')
          }, 'page-component---templates-template-doc-layout-js')
        }
      },
    
      {
        path:'/components/home/AdminInterface/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/AdminInterface.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-admin-interface.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-admin-interface')
          }, 'page-component---pages-components-home-admin-interface-js')
        }
      },
    
      {
        path:'/components/home/CommunityResponse/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/CommunityResponse.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-community-response.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-community-response')
          }, 'page-component---pages-components-home-community-response-js')
        }
      },
    
      {
        path:'/components/home/Footer/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/Footer.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-footer.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-footer')
          }, 'page-component---pages-components-home-footer-js')
        }
      },
    
      {
        path:'/components/home/header/Header/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/header/Header.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-header-header.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-header-header')
          }, 'page-component---pages-components-home-header-header-js')
        }
      },
    
      {
        path:'/components/home/ValueProps/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/ValueProps.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-value-props.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-value-props')
          }, 'page-component---pages-components-home-value-props-js')
        }
      },
    
      {
        path:'/components/home/ValueProps2/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/ValueProps2.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-value-props-2.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-value-props-2')
          }, 'page-component---pages-components-home-value-props-2-js')
        }
      },
    
      {
        path:'/components/home/WhereNext/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/components/home/WhereNext.js'))
            require.ensure([], (require) => {
              const data = require('./json/components-home-where-next.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---components-home-where-next')
          }, 'page-component---pages-components-home-where-next-js')
        }
      },
    
      {
        path:'/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            const Component = preferDefault(require('/Users/noviny/Development/packages/keystone/www/pages/index.js'))
            require.ensure([], (require) => {
              const data = require('./json/index.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---index')
          }, 'page-component---pages-index-js')
        }
      },
    ]},]}
    module.exports = rootRoute


// WEBPACK FOOTER //
// ./.intermediate-representation/split-child-routes.js